<template>
  <div
    class="container-graph h-screen w-screen m-auto flex border border-grey m-20 relative"
  >
    <div class="relative">
      <span v-if="hideMenu" @click="toggleMenu" class="toggle-button">
        <SVGIcon
          name="menu"
          class=""
          :attributes="{ width: 25, height: 25, fill: '#7b7b7b' }"
        />
      </span>
      <div
        class="controls-menu"
        :class="`${hideMenu ? 'hide-menu' : 'show-menu'}`"
      >
        <span
          @click="toggleMenu"
          class="toggle-button hover:bg-grey-light flex justify-center items-center"
        >
          <SVGIcon
            name="close"
            class=""
            :attributes="{ width: 22, height: 22, fill: '#7b7b7b' }"
          />
        </span>
        <div class="w-full px-20 py-20 flex flex-col justify-center">
          <h2 class="mb-4">Instructions:</h2>
          <ol class="mb-8">
            <li class="pb-3">
              Drag the graph around to study regions of interest, and zoom
              in/out with the mouse wheel.
            </li>
            <li class="pb-3">
              The size of the node is proportional to how many messages a
              student has shared with their peers.
            </li>
            <li class="pb-3">
              The thickness (and colour) of the edge between 2 nodes here is
              proportional to how many messages have been exchanged between the
              two peers.
            </li>
          </ol>
          <h2>Filters</h2>
          <div class="mt-3">
            <label
              class="block text-gray-700 text-sm font-bold mb-2"
              for="select_cohort"
              >Choose Cohort</label
            >
            <VueSelect
              :options="cohorts"
              label="name"
              :value="selectedCohort.name"
              @input="cohortSelection"
              :disabled="loader"
            />
          </div>

          <div class="flex w-full mt-10">
            <div class="w-1/2">
              <div class="" style="width: 97%;">
                <label
                  for="from-date"
                  class="block text-gray-700 text-sm font-bold mb-2"
                  >Start Date</label
                >
                <input
                  :disabled="loader"
                  type="date"
                  id="from-date"
                  :value="getInputDateFormat(range.from)"
                  :min="getInputDateFormat(range.fromMin)"
                  :max="getInputDateFormat(range.fromMax)"
                  @input="e => setDate(e, 'start')"
                  @change="render()"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <div class="flex justify-between px-3 text-2xl mt-1">
                  <button
                    @click="stepDate('start', 'back')"
                    class=" cursor-pointer shadow flex justify-center items-center rounded p-1 focus:outline-none hover:shadow-md"
                  >
                    <SVGIcon
                      name="double-left-arrows"
                      class=""
                      :attributes="{ width: 20, height: 20, fill: '#7b7b7b' }"
                    />
                  </button>
                  <button
                    @click="stepDate('start', 'forward')"
                    class=" cursor-pointer shadow flex justify-center items-center rounded p-1 focus:outline-none hover:shadow-md"
                  >
                    <SVGIcon
                      name="double-right-arrows"
                      class=""
                      :attributes="{ width: 20, height: 20, fill: '#7b7b7b' }"
                    />
                  </button>
                </div>
              </div>
            </div>
            <div class="w-1/2">
              <div class="w-full ml-auto" style="width: 97%;">
                <label
                  for="to-date"
                  class="block text-gray-700 text-sm font-bold mb-2"
                  >End Date</label
                >
                <input
                  :disabled="loader"
                  type="date"
                  id="to-date"
                  :value="getInputDateFormat(range.to)"
                  :min="getInputDateFormat(range.toMin)"
                  :max="getInputDateFormat(range.toMax)"
                  @change="render()"
                  @input="e => setDate(e, 'end')"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
                <div class="flex justify-between px-3 text-2xl mt-1">
                  <button
                    @click="stepDate('end', 'back')"
                    class=" cursor-pointer shadow flex justify-center items-center rounded p-1 focus:outline-none hover:shadow-md"
                  >
                    <SVGIcon
                      name="double-left-arrows"
                      class=""
                      :attributes="{ width: 20, height: 20, fill: '#7b7b7b' }"
                    />
                  </button>
                  <button
                    @click="stepDate('end', 'forward')"
                    class=" cursor-pointer shadow flex justify-center items-center rounded p-1 focus:outline-none hover:shadow-md"
                  >
                    <SVGIcon
                      name="double-right-arrows"
                      class=""
                      :attributes="{ width: 20, height: 20, fill: '#7b7b7b' }"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loader" class="loading-wrapper">
      <div class="loading"></div>
      <div style="position: absolute; left: 45%; top: 58%;">
        <span class=" text-grey-darkest font-bold">Loading...</span>
        {{ selectedCohort.name }}
      </div>
    </div>

    <div
      style="height: 100%;"
      class="w-full"
      id="sigma-graph-element"
      ref="sigma-graph-element"
    ></div>
  </div>
</template>

<script>
import { NewConnectionGraph } from "../utils/connectionGraph.js";
import VueSelect from "vue-select";
import axios from "axios";
import SVGIcon from "./SVGIcon";

const cohorts = [
  {
    "id": "-MDOsJnpghrGkie_lcpp",
    "name": "Data Science Learners Course",
    "start_date": "2020-07-28T21:21:00",
    "end_date": "2020-09-29T21:21:00"
  },
  {
    "id": "-MDJOan2NflkVTYzGQK3",
    "name": "CodeVita 2020 | Bannari",
    "start_date": "2020-02-29T19:48:00",
    "end_date": "2020-08-09T19:48:00"
  },
  {
    "id": "-MCkfddpLzSakBd3MrkC",
    "name": "Fun with Python programming (KIET 2023)",
    "start_date": "2020-07-21T09:20:00",
    "end_date": "2020-10-31T09:20:00"
  },
  {
    "id": "-MCaFl4ZDTDQHu18CNpg",
    "name": "Codevita 2020 | GITAM 2021",
    "start_date": "2020-07-18T20:48:00",
    "end_date": "2020-08-30T20:48:00"
  },
  {
    "id": "-MCaFZgacYS5SPygpRVO",
    "name": "Codevita 2020 | GEC 2021",
    "start_date": "2020-07-19T08:45:00",
    "end_date": "2020-08-31T08:45:00"
  },
  {
    "id": "-MBIY3Sssxu5WMPFLsSZ",
    "name": "Daily Coding Challenge July 2020",
    "start_date": "2020-07-03T07:19:00",
    "end_date": "2020-07-16T07:19:00"
  },
  {
    "id": "-M9wJ4YYMWDkFGuiw8XM",
    "name": "Web Master Bootcamp 2020",
    "start_date": "2020-06-17T08:44:00",
    "end_date": "2020-12-31T08:44:00"
  },
  {
    "id": "-M9Nhi5CMscRIafsE3ME",
    "name": "Codevita 2020 | VRSEC",
    "start_date": "2020-06-09T10:51:00",
    "end_date": "2020-07-31T10:51:00"
  },
  {
    "id": "-M9N_wlpQdTpZ8PYlXf3",
    "name": "KIET Adarna 2020",
    "start_date": "2020-06-09T10:04:00",
    "end_date": "2020-07-05T10:04:00"
  },
  {
    "id": "-M8zRyPuPmuIMMYwGne8",
    "name": "Codevita 2020 | GNITS 2021",
    "start_date": "2020-06-04T01:02:00",
    "end_date": "2020-08-31T01:02:00"
  },
  {
    "id": "-M7v9-OHAzFEXrILPsdI",
    "name": "HackWithInfy 2020 Round 2 | VRSEC",
    "start_date": "2020-05-22T06:52:00",
    "end_date": "2020-05-31T06:52:00"
  },
  {
    "id": "-M7gIijLedl8gTXeyINg",
    "name": "Codevita 2020 | KIET 2022",
    "start_date": "2020-05-19T09:40:00",
    "end_date": "2020-07-31T09:40:00"
  },
  {
    "id": "-M7gFxIDunPhGMiIpEOd",
    "name": "Codevita 2020 | VVIT 2021",
    "start_date": "2020-05-18T21:09:00",
    "end_date": "2020-07-30T21:09:00"
  },
  {
    "id": "-M7gBXgCTNjIimBW7-Og",
    "name": "Codevita 2020 | SVEC 2022",
    "start_date": "2020-05-18T21:09:00",
    "end_date": "2020-07-30T21:09:00"
  },
  {
    "id": "-M7gBNVvSilT7Oh55fc3",
    "name": "Codevita 2020 | SVEC 2021",
    "start_date": "2020-05-18T21:08:00",
    "end_date": "2020-07-30T21:08:00"
  },
  {
    "id": "-M7gBGYC0Z18fS4ncyYy",
    "name": "Codevita 2020 | GVP 2021",
    "start_date": "2020-05-18T21:08:00",
    "end_date": "2020-05-30T21:08:00"
  },
  {
    "id": "-M7gB9mH43fjvk-WlA0e",
    "name": "Codevita 2020 | MLRIT 2022",
    "start_date": "2020-05-18T21:07:00",
    "end_date": "2020-07-30T21:07:00"
  },
  {
    "id": "-M7gAxT7Q-rEfI4AgwrM",
    "name": "Codevita 2020 | MLRIT 2021",
    "start_date": "2020-05-18T21:05:00",
    "end_date": "2020-07-30T21:05:00"
  },
  {
    "id": "-M7gA_Tyehq8TXKcjcxV",
    "name": "Codevita 2020 | KIET 2021",
    "start_date": "2020-05-18T21:04:00",
    "end_date": "2020-07-30T21:04:00"
  },
  {
    "id": "-M7Gvz0R0eXbJQEN7Lkc",
    "name": "Placement Foundational Program | Python | HITAM 2021",
    "start_date": "2020-05-14T06:45:00",
    "end_date": "2020-06-14T06:45:00"
  },
  {
    "id": "-M7E1x23AgkylvgpM4nN",
    "name": "HackWIthInfy Round 2 | BVRIT Group",
    "start_date": "2020-05-12T17:17:00",
    "end_date": "2020-05-31T17:17:00"
  },
  {
    "id": "-M7BigRwRt2OliTg2FWi",
    "name": "Hackwithinfy 2020 Round 2 | Test Preparation Pack",
    "start_date": "2020-05-14T18:28:00",
    "end_date": "2020-05-31T18:28:00"
  },
  {
    "id": "-M7BWhsHzw1hXoOqQrCh",
    "name": "Hackwithinfy 2020 Round 2 | Lendi",
    "start_date": "2020-05-13T17:33:00",
    "end_date": "2020-05-31T17:33:00"
  },
  {
    "id": "-M79beRgBjlEfZoj-JrB",
    "name": "Hackwithinfy 2020 Round 2 | GNITS",
    "start_date": "2020-05-13T08:38:00",
    "end_date": "2020-05-31T08:38:00"
  },
  {
    "id": "-M79be6EwbnCC8e7AWHY",
    "name": "Hackwithinfy 2020 Round 2 | VVIT",
    "start_date": "2020-05-13T08:38:00",
    "end_date": "2020-05-31T08:38:00"
  },
  {
    "id": "-M79bdqc5H0NCQiH7ITk",
    "name": "Hackwithinfy 2020 Round 2 | GVP",
    "start_date": "2020-05-13T08:38:00",
    "end_date": "2020-05-31T08:38:00"
  },
  {
    "id": "-M79bdXOpmOTNiR7NcsG",
    "name": "Hackwithinfy 2020 Round 2 | MLRIT",
    "start_date": "2020-05-13T08:38:00",
    "end_date": "2020-05-31T08:38:00"
  },
  {
    "id": "-M79_y1qdYV98UHmhmKy",
    "name": "Hackwithinfy 2020 Round 2 | GPREC",
    "start_date": "2020-05-13T08:33:00",
    "end_date": "2020-05-31T08:33:00"
  },
  {
    "id": "-M72TrnK3aucc9GQyiyu",
    "name": "Codevita 2020 | Lendi",
    "start_date": "2020-05-10T23:24:00",
    "end_date": "2020-07-30T23:24:00"
  },
  {
    "id": "-M6hWv8Mh_ILYivX7yb5",
    "name": "Placement Foundational Program | Python | CMRTC 2021",
    "start_date": "2020-05-07T17:06:00",
    "end_date": "2020-06-07T17:06:00"
  },
  {
    "id": "-M6cwxNUeIPhwkMs8HSK",
    "name": "Placement Foundational Program | Python | MITS 2021",
    "start_date": "2020-05-06T07:44:00",
    "end_date": "2020-06-06T07:44:00"
  },
  {
    "id": "-M6Eb3PeN9pQuVH7_soS",
    "name": "Placement Foundational Program | Python | SASI 2021",
    "start_date": "2020-05-01T09:39:00",
    "end_date": "2020-06-01T09:39:00"
  },
  {
    "id": "-M64WLSAO-wNN4-6c_gC",
    "name": "Advanced Python MLRIT 2022",
    "start_date": "2020-04-29T10:36:00",
    "end_date": "2020-07-31T10:36:00"
  },
  {
    "id": "-M5otSN4Ha4xV4JrO9Qp",
    "name": "Placement Foundational Program | Python | TEC 2021",
    "start_date": "2020-04-26T17:10:00",
    "end_date": "2020-05-26T17:10:00"
  },
  {
    "id": "-M578Lq9_rtEHAwRpSnZ",
    "name": "Placement Foundational Program | Python | Stanley 2021",
    "start_date": "2020-04-17T12:30:00",
    "end_date": "2020-05-17T12:30:00"
  },
  {
    "id": "-M55w6EwbPQ7A_bKX-kA",
    "name": "Placement Foundational Program | Python | SRKR 2021",
    "start_date": "2020-04-17T06:59:00",
    "end_date": "2020-05-17T06:59:00"
  },
  {
    "id": "-M50m94SFjyvife27-zj",
    "name": "Placement Foundational Program | Python | VNR 2021",
    "start_date": "2020-04-16T06:58:00",
    "end_date": "2020-05-16T06:58:00"
  },
  {
    "id": "-M4wigWJi117mCLU6t6A",
    "name": "Placement Foundational Program | Python | Vaagdevi 2021",
    "start_date": "2020-04-15T07:22:00",
    "end_date": "2020-05-15T07:22:00"
  },
  {
    "id": "-M4wgBqie6Qgg3-R-Ye4",
    "name": "Placement Foundational Program | Python | LBRCE 2021",
    "start_date": "2020-04-15T07:13:00",
    "end_date": "2020-05-15T07:13:00"
  },
  {
    "id": "-M4tDPt_bCWPXR4pppm0",
    "name": "Placement Foundational Program | Python | GPREC 2021",
    "start_date": "2020-04-15T15:04:00",
    "end_date": "2020-05-15T15:04:00"
  },
  {
    "id": "-M4ZFwxhV18YDEtMQEGU",
    "name": "Daily Coding Challenge April 2020",
    "start_date": "2020-04-13T01:18:00",
    "end_date": "2020-04-22T01:18:00"
  },
  {
    "id": "-M4IMXcNFsFIWHBsTyVO",
    "name": "CodeVita 2020",
    "start_date": "2020-04-07T06:37:00",
    "end_date": "2020-08-31T06:37:00"
  },
  {
    "id": "-M2xGu91FfhuiRggaXus",
    "name": "Daily Coding Challenge March 2020",
    "start_date": "2020-03-23T01:26:00",
    "end_date": "2020-04-01T01:26:00"
  },
  {
    "id": "-M1ZzzRBBi8Iq7O0DExG",
    "name": "Python (Intro + Advanced + InfyTQ) GEC",
    "start_date": "2020-03-04T10:01:00",
    "end_date": "2020-04-30T10:01:00"
  },
  {
    "id": "-M1W9xsjzRkZistpaL44",
    "name": "Python: Intro + Advanced (MLEW 2021)",
    "start_date": "2020-03-03T16:11:00",
    "end_date": "2020-05-31T16:11:00"
  },
  {
    "id": "-M10yA1lqm3-oermNnTD",
    "name": "Advanced Algorithms & Data Structures (GVP 2021)",
    "start_date": "2020-02-26T14:47:00",
    "end_date": "2020-07-31T14:47:00"
  },
  {
    "id": "-M087XzxZ7WWK4YEn0Q6",
    "name": "Intro to SQL (GVP 2021)",
    "start_date": "2020-02-15T01:55:00",
    "end_date": "2020-04-30T01:55:00"
  },
  {
    "id": "-M086r1VDA79aP774kKi",
    "name": "Python: Intro + Advanced (GVP 2021)",
    "start_date": "2020-02-15T13:52:00",
    "end_date": "2020-04-30T13:52:00"
  },
  {
    "id": "-M-weVa97WfTwHoDtYd0",
    "name": "Intro to SQL (MLRIT)",
    "start_date": "2020-02-13T03:48:00",
    "end_date": "2020-05-31T03:48:00"
  },
  {
    "id": "-M-n3dQXHCf6JEgXFWn6",
    "name": "Fun with Python programming (GNITS 2023)",
    "start_date": "2020-02-11T07:06:00",
    "end_date": "2020-05-31T07:06:00"
  },
  {
    "id": "-M-g6NXqoS3LMXK6JksF",
    "name": "Intro to SQL (Lendi)",
    "start_date": "2020-02-09T22:40:00",
    "end_date": "2020-05-30T22:40:00"
  },
  {
    "id": "-M-g68SS4rQ0op-_Zs0x",
    "name": "Intro to SQL (SVEC)",
    "start_date": "2020-02-09T22:39:00",
    "end_date": "2020-05-30T22:39:00"
  },
  {
    "id": "-M-g5zGnZa8BOat_Y37d",
    "name": "Intro to SQL (VVIT)",
    "start_date": "2020-02-09T22:39:00",
    "end_date": "2020-05-30T22:39:00"
  },
  {
    "id": "-M-g5pCW5dA6hDPbntDl",
    "name": "Intro to SQL (KIET)",
    "start_date": "2020-02-09T22:38:00",
    "end_date": "2020-05-30T22:38:00"
  },
  {
    "id": "-M-Np85R00OR0hYe2UwP",
    "name": "Introduction to SQL",
    "start_date": "2020-02-06T16:48:00",
    "end_date": "2020-07-31T16:48:00"
  },
  {
    "id": "-Lzack93nt9OsLidX449",
    "name": "Python : Intro + Advanced + INFYTQ (MLRIT)",
    "start_date": "2020-01-27T10:52:00",
    "end_date": "2020-03-31T10:52:00"
  },
  {
    "id": "-LzacFf0HYzyfDFIJM-I",
    "name": "Advanced Python and INFYTQ (MLRIT)",
    "start_date": "2020-01-27T10:50:00",
    "end_date": "2020-04-30T10:50:00"
  },
  {
    "id": "-LzaZdi3Sq7yAHMlDVjL",
    "name": "Advanced Python and INFYTQ (KIET)",
    "start_date": "2020-01-27T10:35:00",
    "end_date": "2020-03-31T10:35:00"
  },
  {
    "id": "-LzaWIH7WwVSD9X3Tn-M",
    "name": "Advanced Python + InfyTQ (KIET)",
    "start_date": "2020-01-27T10:13:00",
    "end_date": "2020-03-31T10:13:00"
  },
  {
    "id": "-LzHDgsOe9xQugMwnN5L",
    "name": "Java Programming (MLRIT 2021)",
    "start_date": "2020-01-22T23:46:00",
    "end_date": "2020-03-30T23:46:00"
  },
  {
    "id": "-LzCkQRumqP1CRolUYw0",
    "name": "InfyTQ (VVIT 2021)",
    "start_date": "2020-01-22T02:56:00",
    "end_date": "2020-02-29T02:56:00"
  },
  {
    "id": "-Lz0Tz_Kc3QWJajyWqe0",
    "name": "Java Programming Introduction (MLRIT)",
    "start_date": "2020-01-20T05:45:00",
    "end_date": "2020-04-30T05:45:00"
  },
  {
    "id": "-Ly73qUKWRzQwzZGFNrB",
    "name": "Fun with Programming (GVP)",
    "start_date": "2020-01-09T14:12:00",
    "end_date": "2020-01-19T14:12:00"
  },
  {
    "id": "-LxpWTtzQQQ7hP6SDEdE",
    "name": "Python Programming Introduction (Lendi)",
    "start_date": "2020-01-06T11:44:00",
    "end_date": "2020-03-31T11:44:00"
  },
  {
    "id": "-LwORH3_ZbenpjsYXQLm",
    "name": "Fun with Python Programming (BEC + BWEC)",
    "start_date": "2019-12-19T14:35:00",
    "end_date": "2020-03-31T14:35:00"
  },
  {
    "id": "-LvymeA8GiVIZiSuSJWz",
    "name": "Java Programming - SVEC",
    "start_date": "2019-12-12T22:17:00",
    "end_date": "2019-04-29T22:17:00"
  },
  {
    "id": "-LvsQyQb2SJIz3XOI0eK",
    "name": "Fun with Java Programming (GNITS 2022)",
    "start_date": "2019-12-12T04:47:00",
    "end_date": "2019-12-26T04:47:00"
  },
  {
    "id": "-LvsKxZwIB7KkkUjm6Aw",
    "name": "Fun with Python Programming (GNITS 2022)",
    "start_date": "2019-12-12T16:21:00",
    "end_date": "2019-12-19T16:21:00"
  },
  {
    "id": "-Lvd15izuF4AjXmlB0I3",
    "name": "Python Programming - SVEC",
    "start_date": "2019-12-09T17:00:00",
    "end_date": "2020-02-29T17:00:00"
  },
  {
    "id": "-LtNa-tE-j5sKftiDtWO",
    "name": "Java Programming Bridge (VVIT)",
    "start_date": "2019-11-11T03:52:00",
    "end_date": "2019-12-31T03:52:00"
  },
  {
    "id": "-LsuYaenfVrIjgKbqOVr",
    "name": "Interview Preparation (GNITS 2020)",
    "start_date": "2019-11-04T19:52:00",
    "end_date": "2020-10-30T19:52:00"
  },
  {
    "id": "-Ls_iTlccf5cgwCA5eJT",
    "name": "Advanced Algorithms & Data Structures (GNITS 2020)",
    "start_date": "2019-11-02T06:48:00",
    "end_date": "2020-04-30T06:48:00"
  },
  {
    "id": "-LsSkVLXR5wtIsKhwJ6e",
    "name": "Advanced Algorithms & Data Structures (MLRIT 2020)",
    "start_date": "2019-10-30T17:40:00",
    "end_date": "2020-04-30T17:40:00"
  },
  {
    "id": "-LrTd4v5UCyv2X5Z49Vm",
    "name": "Edyst Live Sessions (MLRIT)",
    "start_date": "2019-10-01T11:32:00",
    "end_date": "2019-10-31T11:32:00"
  },
  {
    "id": "-LrJUTQe3W-brJpf3Hrv",
    "name": "Edyst Live Sessions (GNITS)",
    "start_date": "2019-10-16T00:14:00",
    "end_date": "2019-11-30T00:14:00"
  },
  {
    "id": "-LqaHPKBXZp2wN732KJa",
    "name": "Trianz Preparation",
    "start_date": "2019-10-07T12:54:00",
    "end_date": "2019-10-14T12:54:00"
  },
  {
    "id": "-Lph3Zd3VQfYR5dhDcst",
    "name": "Fun with Python Programming",
    "start_date": "2019-09-26T09:35:00",
    "end_date": "2019-10-13T09:35:00"
  },
  {
    "id": "-LpYYNMOXhRIgJoynK61",
    "name": "WIPRO Elite National Talent Hunt 2019",
    "start_date": "2019-09-24T13:50:00",
    "end_date": "2019-10-19T13:50:00"
  },
  {
    "id": "-LpDZ8a6946IwgvxfLLo",
    "name": "Java Programming Bridge (GNITS)",
    "start_date": "2019-09-21T12:05:00",
    "end_date": "2019-10-31T12:05:00"
  },
  {
    "id": "-Lp4eQUt3tsxTdX7KjwT",
    "name": "Java Programming Bridge",
    "start_date": "2019-09-19T06:36:00",
    "end_date": "2019-10-17T06:36:00"
  },
  {
    "id": "-Lo5TwDMhzH2iApin_e8",
    "name": "Python Programming - Aditya",
    "start_date": "2019-09-06T12:09:00",
    "end_date": "2019-12-31T12:09:00"
  },
  {
    "id": "-LnGQe_3Ii4Fwi-aQfNR",
    "name": "Python Programming - KIET",
    "start_date": "2019-08-27T16:52:00",
    "end_date": "2019-11-30T16:52:00"
  },
  {
    "id": "-Lme_kBab-qpS6aig3Bk",
    "name": "Python Programming",
    "start_date": "2019-08-18T15:54:00",
    "end_date": "2019-11-30T15:54:00"
  },
  {
    "id": "-LmPt6XDynncxdZEx_9O",
    "name": "Python Programming: Intro and Advanced",
    "start_date": "2019-08-17T14:45:00",
    "end_date": "2019-12-31T14:45:00"
  },
  {
    "id": "-Lm4QMM6ze0m-lJcPqd2",
    "name": "KIET Abhiyaan 2019",
    "start_date": "2019-08-12T10:42:00",
    "end_date": "2019-08-27T10:42:00"
  },
  {
    "id": "-LlYD8rx32GNI38U2u3u",
    "name": "Python programming - Introduction",
    "start_date": "2019-08-05T19:18:00",
    "end_date": "2019-11-29T19:18:00"
  },
  {
    "id": "-LlVvi5AbMfuEmC2VnZz",
    "name": "JP Morgan Preparation",
    "start_date": "2019-08-01T08:38:00",
    "end_date": "2019-08-08T08:38:00"
  },
  {
    "id": "-Lk4mUCw_TopVuYtaJMD",
    "name": "EPAM Preparation 2019-20",
    "start_date": "2019-07-18T15:52:00",
    "end_date": "2019-08-31T15:52:00"
  },
  {
    "id": "-LjuihHNAuNAPgiULKNJ",
    "name": "Complete Coding Tests & Interview Preparation 2019-20",
    "start_date": "2019-07-15T12:20:00",
    "end_date": "2019-11-30T12:20:00"
  },
  {
    "id": "-Lih08l4Z-tdl3lCCuIq",
    "name": "EPAM Preparation 2019",
    "start_date": "2019-06-30T10:10:00",
    "end_date": "2019-09-30T10:10:00"
  },
  {
    "id": "-LiGjJfxJUgwdCz8Bkih",
    "name": "CodeVita Assessment 26th June",
    "start_date": "2019-06-25T15:02:00",
    "end_date": "2019-07-01T15:02:00"
  },
  {
    "id": "-Lg0m9bJt7DeMhuUa4Sk",
    "name": "CodeVita 2019",
    "start_date": "2019-05-23T16:10:00",
    "end_date": "2019-06-30T16:10:00"
  },
  {
    "id": "-LfIiz7zpJL8XSezhHW5",
    "name": "Practice Tests",
    "start_date": "2019-05-01T05:33:00",
    "end_date": "2019-07-31T05:33:00"
  },
  {
    "id": "-LekPT-mgZPMSpUPAgHj",
    "name": "Java Interview Preparation",
    "start_date": "2019-05-12T08:57:00",
    "end_date": "2019-08-31T08:57:00"
  },
  {
    "id": "-Lcea5GLq1faUweSO_Jj",
    "name": "Edyst Advance Assessment",
    "start_date": "2019-04-01T09:18:00",
    "end_date": "2019-04-22T09:18:00"
  },
  {
    "id": "-LYofhBh0bYButdvA7XZ",
    "name": "Edyst Industry Assessments",
    "start_date": "2019-02-15T16:58:00",
    "end_date": "2020-02-21T16:58:00"
  },
  {
    "id": "-LXxmdzvkC9yS_HmDx6G",
    "name": "Advanced Algorithms & DS (Fast-Track) Batch #1",
    "start_date": "2019-02-05T13:11:00",
    "end_date": "2019-05-31T17:30:00"
  },
  {
    "id": "-LXxmIdJxpdntghwp52q",
    "name": "Java Programming (Fast-Track) Batch #1",
    "start_date": "2019-02-05T13:09:00",
    "end_date": "2019-05-31T18:10:00"
  },
  {
    "id": "-LNYou5DLByKcR1TxXi5",
    "name": "Java Programming Batch #2",
    "start_date": "2018-09-30T17:16:00",
    "end_date": "2019-03-01T17:16:00"
  },
  {
    "id": "-LLJMFH-sV-PI8FbTNyx",
    "name": "Advanced Algorithms & Data Structures #2",
    "start_date": "2018-09-23T07:30:00",
    "end_date": "2019-01-31T08:53:00"
  },
  {
    "id": "-LJ31N_8Qzc6GJEyQbiD",
    "name": "Fundamentals of Programming Batch #1",
    "start_date": "2018-08-04T08:21:00",
    "end_date": "2019-03-31T09:21:00"
  },
  {
    "id": "-LH9va5_JPwPBRO3IgEt",
    "name": "Advanced Algorithms & Data Structures Batch #1",
    "start_date": "2018-08-04T18:00:00",
    "end_date": "2019-08-31T11:30:00"
  },
  {
    "id": "-LH9vGtIFtnl7HEDXf2h",
    "name": "Java Programming Batch #1",
    "start_date": "2018-08-04T18:00:00",
    "end_date": "2019-03-31T07:57:00"
  }
]

const fetchConnectionGraph = async cohort_id => {
  let BASE_URL = "//prod-api.edyst.com/api/v1";
  if (process.env.NODE_ENV === "production") {
    BASE_URL = "//prod-api.edyst.com/api/v1";
  }
  return axios.get(`${BASE_URL}/conngraph?cohort_id=${cohort_id}`);
};

export default {
  name: "GraphContainer",
  components: {
    SVGIcon,
    VueSelect
  },
  async created() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    // console.log(token)

    // If token fetch cohorts - staging-api
    // reset hard coded cohort list
    // select first cohort - set dates from this cohort start/end

    // else continue with hard coded cohort data

    // trigger cohortChange()

    if (token) {
      const cohorts_url = `https://dev-api.edyst.com/api/v1/cohorts/usercohorts`;
      this.cohorts = [];
      this.loader = true;
      const cohorts_list = await axios.get(cohorts_url, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": token
        }
      });
      this.cohorts = cohorts_list.data.cohorts;
      this.selectedCohort = this.cohorts[0];
      this.loader = false;
    } 

    this.cohortChange();
  },

  data() {
    return {
      cg: undefined,
      userMap: {},
      messageMap: {},
      sigmajsInstance: undefined,
      stopForceAtlas2TimeoutID: undefined,
      selectedCohort: { id: "-M9Nhi5CMscRIafsE3ME", name: "CodeVita 2020" }, // CodeVita 2020
      excludeNames: "Demo Account, Rishist Edyst",
      range: {
        from: "",
        to: "",
        toMin: "",
        toMax: "",
        fromMin: "",
        fromMax: ""
      },
      cohorts,
      loader: false,
      hideMenu: false
    };
  },
  methods: {
    toggleMenu() {
      this.hideMenu = !this.hideMenu;
    },
    async cohortChange() {
      if (!this.selectedCohort) {
        return;
      }
      this.loader = true;
      const res = await fetchConnectionGraph(this.selectedCohort.id);

      const {
        data: { userMap, messageMap }
      } = res;

      this.userMap = userMap;
      this.messageMap = messageMap;

      let cg = new NewConnectionGraph(this.userMap, this.messageMap);
      console.log(cg.firstMessageOn, cg.lastMessageOn);

      let start_date = this.selectedCohort.start_date
        ? new Date(this.selectedCohort.start_date)
        : cg.firstMessageOn;
      this.initializeDateRanges(start_date);

      this.cg = cg;
      this.loader = false;
      this.render();
    },
    initializeDateRanges(start) {
      let startDate = new Date(start);
      startDate.setDate(1);
      this.range.from = startDate;
      this.range.to = new Date()
      // this.range.to = this.getLastDayofMonth(startDate);

      let now = new Date();
      now.setDate(1);
      now.setHours(0, 0, 0, 0);

      this.range.fromMin = startDate;
      this.range.fromMax = this.getFromMax(now);
      this.range.toMin = this.getDate(startDate);
      this.range.toMax = new Date();
      this.range.toMax.setHours(0, 0, 0, 0);
    },
    cohortSelection(cohort) {
      if (!cohort) return;
      this.selectedCohort = cohort;
      this.cohortChange();
    },
    getInputDateFormat(date) {
      if (date) {
        let d = date.getDate().toString();
        d = d < 10 ? d.padStart(2, 0) : d;
        let m = (date.getMonth() + 1).toString();
        m = m < 10 ? m.padStart(2, 0) : m;
        let y = date.getFullYear();

        return `${y}-${m}-${d}`;
      }
    },
    setDate(e, type) {
      let date = new Date(e.target.value);
      if (type === "start") {
        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        this.range.from = date;
      }
      if (type === "end") {
        date.setHours(0, 0, 0, 0);
        this.range.to = date;
      }
    },
    getDate(date, type) {
      if (!date) return;

      switch (type) {
        case "reverse": {
          if (date.getMonth() === 0) {
            return new Date(date.getFullYear() - 1, 11, 1);
          } else {
            return new Date(date.getFullYear(), date.getMonth() - 1, 1);
          }
        }
        default: {
          if (date.getMonth() === 11) {
            return new Date(date.getFullYear() + 1, 0, 1);
          } else {
            return new Date(date.getFullYear(), date.getMonth() + 1, 1);
          }
        }
      }
    },
    getFromMax(date) {
      if (date.getMonth() === 11) {
        return new Date(date.getFullYear() + 1, 0, 1);
      } else {
        return new Date(date.getFullYear(), date.getMonth(), 1);
      }
    },
    stepDate(type, mode) {
      if (this.loader) return;
      switch (type) {
        case "start":
          {
            let { from, fromMin, fromMax } = this.range;
            if (mode === "back") {
              let disabled = from.getTime() <= fromMin.getTime();
              this.range.from = disabled ? from : this.getDate(from, "reverse");
              if (disabled) return; //skip render
            }
            if (mode === "forward") {
              let disabled = from.getTime() >= fromMax.getTime();
              this.range.from = disabled ? from : this.getDate(from);
              if (disabled) return;
            }
            this.render(true);
          }
          break;
        case "end":
          let { to, toMin, toMax } = this.range;
          if (mode === "back") {
            let disabled = to.getTime() <= toMin.getTime();
            this.range.to = disabled ? to : this.getDate(to, "reverse");
            if (disabled) return;
          }
          if (mode === "forward") {
            let disabled = to.getTime() >= toMax.getTime();
            this.range.to = disabled
              ? to
              : this.getLastDayofMonth(this.getDate(to));
            if (disabled) return;
          }
          this.render(true);
        default:
          break;
      }
    },
    getLastDayofMonth(date) {
      let d = this.getDate(date);
      d = new Date(d.getFullYear(), d.getMonth(), 0);
      return d;
    },
    async render(refresh=false) {
      this.cg.makeNodeAndEdgeMaps(this.cg.userMap, this.cg.messageMap);

      if (this.sigmajsInstance) {
        this.sigmajsInstance.graph.kill();
        clearTimeout(this.stopForceAtlas2TimeoutID);
        this.$refs["sigma-graph-element"].innerHTML = "";
      }

      const graph = this.cg.getGraph({
        filters: {
          cohort_id: this.selectedCohort.id,
          message_from: this.range.from,
          message_to: this.range.to,
          exclude_names: this.excludeNames.split(",").map(s => s.trim())
        }
      });

      console.log(graph, window.innerWidth/2, window.innerHeight/2)

      this.sigmajsInstance = new window.sigma({
        graph,
        renderer: {
          container: document.getElementById("sigma-graph-element"),
          type: "canvas"
        },
        settings: {
          labelThreshold: 15,
          minNodeSize: 10,
          maxNodeSize: 25,
          minEdgeSize: 0.1,
          maxEdgeSize: 10,
          defaultEdgeType: "curve"
        }
      });
        // this.sigmajsInstance.refresh()
      if(refresh){
        console.log("refresh")
      } else {
        // this.sigmajsInstance.graph.nodes("5b97db745d92ae686a8d9845").fixed = true
        // this.sigmajsInstance.graph.nodes("5b97db745d92ae686a8d9845").x = 0
        // this.sigmajsInstance.graph.nodes("5b97db745d92ae686a8d9845").y = 0
        this.sigmajsInstance.startForceAtlas2({
          worker: true,
          barnesHutOptimize: true,
          strongGravityMode: true
        });
        this.stopForceAtlas2TimeoutID = setTimeout(() => {
          this.sigmajsInstance.stopForceAtlas2();
          // this.sigmajsInstance.refresh()
          console.log(this.sigmajsInstance.graph.nodes())
        },100);
      }
    }
  }
};
</script>
<style scoped>
.loading-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  background: white;
}
.loading {
  height: 0;
  width: 0;
  padding: 15px;
  border: 6px solid #ccc;
  border-right-color: #888;
  border-radius: 22px;
  animation: rotate 1s infinite linear;
  position: absolute;
  left: 50%;
  top: 50%;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.controls-menu {
  position: absolute;
  z-index: 999999;
  background: white;
  top: 0;
  min-width: 300px;
  width: 500px;
  height: 100%;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.4);
}
.toggle-button {
  cursor: pointer;
  position: absolute;
  font-size: 28px;
  z-index: 999999;
  user-select: none;
  top: 5px;
  left: 5px;
  width: 30px;
  height: 30px;
}

.hide-menu {
  animation: slide-out 200ms ease-out forwards;
  animation-timing-function: cubic-bezier(0.08, 0.72, 0.5, 1.11);
}
.show-menu {
  animation: slide-in 400ms ease-in forwards;
  animation-timing-function: cubic-bezier(0.08, 0.72, 0.5, 1.11);
}

@keyframes slide-in {
  0% {
    transform: translateX(-500px);
  }
  100% {
    transform: translateX(0px);
  }
}
@keyframes slide-out {
  0% {
    transform: translateX(0px);
  }
  100% {
    transform: translateX(-500px);
  }
}
</style>
